import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchPurchaseOrderAttachments } from '@/api/orders';

export const purchaseOrderAttachmentKeys = {
  detail: (poId: string) => ['purchaseOrderAttachments', poId] as const,
};

export function usePurchaseOrderAttachments(poId: string | null | undefined) {
  return useQuery({
    queryKey: purchaseOrderAttachmentKeys.detail(poId ?? ''),
    queryFn: async () => {
      const res = await fetchPurchaseOrderAttachments(poId!);
      return res.data;
    },
    enabled: !!poId,
    staleTime: 30_000,
  });
}

export function usePurchaseOrderAttachmentsRefresh(poId: string) {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: purchaseOrderAttachmentKeys.detail(poId),
    });
}
